import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { LoginService } from '../../service/login.service';
import { LocalStorageService } from '../../service/local-storage.service';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginRequestModel } from '../../models/loginrequest.model';
import { LoginResultModel } from '../../models/loginresult.model';
import { EMPTY, Subscription, catchError, finalize } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SettingsModel } from 'src/app/models/setting.model';
import { SpinnerService } from 'src/app/service/spinner.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  password = '';
  errorMessage = '';
  sub = new Subscription;
  loginRequestModel = new LoginRequestModel();
  queryparam = '';

  constructor(
    private translate: TranslateService,
    private loginservice: LoginService,
    private localstorageservice: LocalStorageService,
    private route: ActivatedRoute,
    private router: Router,
    private spinnerService: SpinnerService
  ) { }

  ngOnInit() {
    this.sub = this.route
      .params
      .subscribe(params => {
        this.loginRequestModel.ClinicId = params['clinicid']
      });
  };

  login() {
    this.loginRequestModel.Password = this.password;
    this.spinnerService.show(this.translate.instant('PAGES.LOGIN.LOGGING_IN'));
    this.errorMessage = '';
    this.loginservice.login(this.loginRequestModel).pipe(
      catchError(err => {
        this.errorMessage = err;
        return EMPTY; // Prevents the completion handler from firing in case of error
      }),
      finalize(() => this.spinnerService.hide()) // Ensures the spinner is hidden in both success and error cases
    ).subscribe((response: LoginResultModel) => {
      if (response.status === 'failure') {
        this.errorMessage = this.translate.instant('ERROR.LOGIN.INVALID_PASSWORD');
        return;
      }

      this.saveLoginData(response);
      this.router.navigate(['checkin']);
    });
  }

  private saveLoginData(response: LoginResultModel) {
    this.localstorageservice.set('settings', new SettingsModel(
      response.logo,
      response.backgroundColorEnd,
      response.backgroundColorStart,
      response.textColor
     ));
    this.localstorageservice.setToken(response.token);
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
  
}
